module.exports = __webpack_public_path__ + "static/media/others4.e898045d.png";